import { render } from "./App.vue?vue&type=template&id=f35c7b36"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f35c7b36&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\Unimagem\\ead\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__